module.exports = __webpack_public_path__ + "static/media/版头@2x.4ca841c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/版头@2x.png
// module id = 407
// module chunks = 0